<template>
	<div class="comp">
		<el-button v-if="card===null" @click="add" type="primary" plain size="small" style="padding:12px 20px;font-size: 14px;margin-right: 10px;">添加优惠券</el-button>
		<span style="margin:0 10px 0 0;" v-if="card">
			当前优惠券：
			<span style="color:#1890FF">
				{{card.coupon_name}}({{getDiscountType(card.apply_range.order_type)}}券)
				<span v-if="card.activity_type===1">
					满{{card.money_top}}元可用
				</span>
				<span v-if="card.activity_type===2">
					满{{card.rebate_top}}元可用，
					<span v-if="card.rebate_limit>0">最高抵扣{{card.rebate_limit}}元</span>
					<span v-else></span>
				</span>
			</span>
		</span>
		<el-button v-if="card" @click="del" type="danger" size="small" style="margin-right: 10px;">删除优惠券</el-button>
		<el-dialog :custom-class="'customClass'" :visible.sync="dialogState" :close-on-click-modal="false" width="420px" :append-to-body="true" @opened="opened">
			<span style="padding:0 10px 0 30px;">优惠券:</span>
			<el-input v-model="code" placeholder="请录入顾客优惠券" @keyup.enter.native="submitCode" ref="input" style="width:250px;"></el-input>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:false,
				
				code:'',
				
				card:null,
				
				total:0,
			}
		},
		props: {
			userInfo:{
				default:()=>{
					return null
				}
			},
			arr:{
				default:()=>{
					return []
				}
			},
			discountCard:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				if(n===false){
					this.code=''
					this.$emit('submit','close')
				}
			},
			userInfo(n,o){
				if(n._id!==o._id){
					this.code=''
					this.card=null;
					if(this.discountCard&&this.discountCard._id){
						this.card = this.discountCard
						console.log(this.card)
					}
				}
			},
			arr(){
				this.getTotal();
			},
		},
		mounted() {
			
		},
		methods: {
			opened(){
				this.$nextTick(()=>{
					this.$refs.input.focus();
				})
			},
			add(){
				if(this.$public.isNull(this.userInfo._id)){
					this.$message({
						message: '请选择顾客和宠物',
						type: 'error'
					});
					return ;
				}
				let len = this.arr.length;
				if(len===0){
					this.$message({
						message: '请先添加商品',
						type: 'error'
					});
					return ;
				}
				let canActivity_state = false;
				for(let i=0;i<len;i++){
					if(!this.$public.isNull(this.arr[i].activityId)){
						this.$message({
							message: '列表中商品有参加活动，不可使用优惠券',
							type: 'error'
						});
						return ;
					}
					if(this.arr[i].canActivity!==false){
						canActivity_state = true;
					}
				}
				if(canActivity_state===false){
					this.$message({
						message: '套餐内商品不能使用优惠券',
						type: 'error'
					});
					return ;
				}
				this.dialogState=true;
				this.getTotal();
			},
			getDiscountType(type){
				if(type===1){
					return '通用'
				}else if(type===2){
					return '消费'
				}else if(type===3){
					return '美容'
				}else if(type===4){
					return '医疗'
				}else if(type===5){
					return '洗澡'
				}else{
					return '未知'
				}
			},
			getTotal(){
				this.total=0;
				for(let i=0;i<this.arr.length;i++){
					if(
						(this.$route.query.eid&&this.$route.query.eid.substr(0,2)==='BL')||
						(this.arr[i].replaceType===0&&this.arr[i].canActivity!==false)||
						(this.$route.path==='/mendian/shouyin')
					){
						if(this.arr[i].allowWholesale===0){
							this.total = this.$public.jia(this.total,this.$public.cheng(this.arr[i].originalPrice,this.arr[i].goodsDosage))
						}else{
							this.total = this.$public.jia(this.total,this.$public.cheng(this.arr[i].originalPrice,this.arr[i].num))
						}
					}
				}
				if(this.card!==null){
					if(this.total<this.card.money_top){
						this.$message({
							message: '未打折商品总金额不足 '+this.card.money_top+' 元，优惠券已取消',
							type: 'error'
						});
						this.card=null;
						this.$emit('submit',null)
						return ;
					}
				}
			},
			del(){
				this.card = null;
				this.code='';
				this.$emit('submit',this.card)
			},
			submitCode(){
				this.getCardMsg();
			},
			getCardMsg(){
				console.log(this.total)
				this.$http.get('/api/Member/ExistCoupon', {no:this.code,memberId:this.userInfo._id}).then(res => {
					this.cord='';
					if (res.code == 0) {
						this.card = res.data;
						if(this.card.activity_type==1){  // 满减
							if(this.total<this.card.money_top){
								this.$message({
									message: '未打折商品总金额满 '+this.card.money_top+' 元才可以使用此优惠券',
									type: 'error'
								});
								this.card=null;
								this.$emit('submit',null)
								return ;
							}
						}else if(this.card.activity_type==2){   // 折扣
							if(this.total<this.card.rebate_top){
								this.$message({
									message: '应付金额满 '+this.card.rebate_top+' 元才可以使用此优惠券',
									type: 'error'
								});
								this.card = null;
								this.$emit('submit',null)
								return ;
							}
						}
						
						if(this.card.use_status===3){
							this.$message({
								message: this.card._no+' 优惠券已过期',
								type: 'error'
							});
							return ;
						}else if(this.card.use_status===2){
							this.$message({
								message: this.card._no+' 优惠券已使用',
								type: 'error'
							});
							return ;
						}else if(this.card.use_status===0){
							this.$message({
								message: this.card._no+' 优惠券不可用',
								type: 'error'
							});
							return ;
						}else if(this.card.use_status===1){
							this.$nextTick(()=>{
								this.dialogState=false;
							})
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit',this.card)
						}
					}else{
						this.$emit('submit',null)
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		display: inline-block;
		margin-left:50px;
		::v-deep .customClass{
			border-radius: 10px;
		}
		.dialog{
			z-index: 2005;
			.scanBox{
				text-align: center;
				padding-top:30px;
				.scanImg{
					width:90px;
				}
				.scanText{
					font-size: 24px;
					padding:30px 0 10px;
				}
				.scanA{
					font-size: 16px;
					padding:10px 0 10px;
					color:#797979;
					cursor: pointer;
				}
			}
		}
	}
</style>
